// extracted by mini-css-extract-plugin
export default {"appHeader":"Header_appHeader__z6bJx"};